import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const FillClock = () => (
  <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 1.5C4.8675 1.5 1.5 4.8675 1.5 9C1.5 13.1325 4.8675 16.5 9 16.5C13.1325 16.5 16.5 13.1325 16.5 9C16.5 4.8675 13.1325 1.5 9 1.5ZM12.2625 11.6775C12.1575 11.8575 11.97 11.955 11.775 11.955C11.6775 11.955 11.58 11.9325 11.49 11.8725L9.165 10.485C8.5875 10.14 8.16 9.3825 8.16 8.715V5.64C8.16 5.3325 8.415 5.0775 8.7225 5.0775C9.03 5.0775 9.285 5.3325 9.285 5.64V8.715C9.285 8.985 9.51 9.3825 9.7425 9.5175L12.0675 10.905C12.3375 11.0625 12.4275 11.4075 12.2625 11.6775Z"
      fill="#8D8D9E"
    />
  </svg>
)

export default withDefaultStyles(FillClock)
